<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/contacts/">Customers</a></li>
      <li class="breadcrumb-item active" aria-current="page">View Customer</li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <div class="text-right float-right">
        <button (click)="editCustomers()" class="btn btn-orange ml-2">Edit Customer</button>
      </div>
    </div>
  </div>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black"><b>Details</b></h2>
          <div class="row mt-3">
            <div class="col-lg-4 col-sm-6">
              <label class="text-black"><b>Customer Type</b> : {{editContacts.customerType | titlecase}}</label>
            </div>
            <div class="col-lg-4 col-sm-6">
                  <label class="text-black"><b>Company Name</b> : {{editContacts.companyName}}</label>
            </div>
            <div class="col-lg-4 col-sm-6">
              <label class="text-black"><b>Name</b> : {{editContacts.contactName}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <label class="text-black"><b>Email</b> : {{editContacts.email}}</label>
            </div>
            <div class="col-lg-4 col-sm-6">
              <label class="text-black"><b>Phone Number</b> : {{editContacts.mobile}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" *ngFor="let add of addresses">
      <div class="col">
        <ul class="list-inline tab-list">
          <li class="list-inline-item ml-2"><a class="list-inline-item" (click)=" tabChange('address');"
                                               [ngClass]="{'active': tabClicked === 'address'}">Address</a></li>
          <li class="list-inline-item ml-3"><a class="nav-link warehouses" (click)=" tabChange('instructions');"
                                               [ngClass]="{'active': tabClicked === 'instructions'}">Instructions</a>
          </li>
        </ul>
        <div class="inner-box" *ngIf="tabClicked == 'address'">
          <div class="row">
            <div class="col-md-4">
              <label class="text-black"><b>Address Type</b> : {{add.addressType | titlecase}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col-4">
                  <label class="text-black"><b>Address 1</b> : {{add.address1}}</label><br>
                </div>
                <div class="col-4">
                  <label class="text-black"><b>Address 2</b> : {{add.address2}}</label><br>
                </div>
                <div class="col-4">
                  <label class="text-black"><b>City</b> : {{add.city}}</label><br>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="text-black"><b>State</b> : {{add.state}}</label><br>
                </div>
                <div class="col-4">
                  <label class="text-black"><b>Zip</b> : {{add.zip}}</label><br>
                </div>
                <!--<div class="col-4">
                  <label class="text-black"><b>Geo Code</b> : {{add.geoCode}}</label><br>
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="inner-box" *ngIf="tabClicked == 'instructions'">
          <div class="row mt-3">
            <div class="col-lg-5 col-sm-6">
              <label class="text-black"><b>Instructions</b> : {{editContacts.deliveryInstructions}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/contacts" class="btn btn-cancel">Close</button>
    </div>
  </div>
</div>
